// Lib
import * as yup from 'yup';
import { patternRxpCheckEng } from 'lib/helpers';

export const schema = yup.object({
	email: yup.string().email().required(),
	companyName: yup
		.string()
		.matches(patternRxpCheckEng, 'Use Latin symbols only.')
		.required('Name is required'),
	format: yup.string().when('groupFormat', {
		is: 'Dry powder',
		then: yup.string().required('Format is required')
	}),
	solution: yup.string().when('packagingGroup', {
		is: 'Other2',
		then: yup.string().required('Solution is required')
	}),
	lastName: yup
		.string()
		.matches(patternRxpCheckEng, 'Use Latin symbols only.')
		.required('Last lastname is required'),
	firstName: yup
		.string()
		.matches(patternRxpCheckEng, 'Use Latin symbols only.')
		.required('First firstname is required'),
	target: yup
		.string()
		.matches(patternRxpCheckEng, 'Use Latin symbols only.')
		.required('Field is required'),
	activityRange: yup.string().when('groupRadio3', {
		is: 'Other4',
		then: yup.string().required('Field is required')
	}),
	compoundsPurity: yup.string().when('groupRadio2', {
		is: 'Other3',
		then: yup.string().required('Field is required')
	}),
	setSize: yup
		.string()
		.matches(patternRxpCheckEng, 'Use Latin symbols only.')
		.nullable()
		.notRequired(),
	dmsoWater: yup.string().nullable().notRequired(),
	DMSOD6Solution: yup.string().nullable().notRequired(),
	groupRadio: yup.string().nullable().notRequired(),
	selectivity: yup.string().nullable().notRequired(),
	inquiry: yup
		.string()
		.matches(patternRxpCheckEng, 'Use Latin symbols only.')
		.required('Field is required'),
	title: yup.string().nullable().required('Selecting the variant field is required'),
	compoundFormat: yup.string().nullable().required('Selecting the variant field is required'),
	groupFormat: yup.string().nullable().when('compoundFormat', {
		is: 'format',
		then: yup.string().nullable().required('Selecting the variant radio Button is required')
	}),
	packagingGroup: yup.string().nullable().when('compoundFormat', {
		is: 'solution',
		then: yup.string().nullable().required('Selecting the variant radio Button is required')
	}),
	groupRadio2: yup.string().nullable().required('Selecting the variant field is required'),
	groupRadio3: yup.string().nullable().required('Selecting the variant field is required')
}).required();

export type FormData = yup.InferType<typeof schema>;
